let React = require("react");

let Toast = require("../../Toast.jsx");

let ContentServerClient =  require("../../../ContentServerClient.js");

class InvitationsToastHub extends React.Component {

    constructor(){
        super();

        // TODO fix this
        this.state = {invitedTo: {show: true, hubs: []}}
    }

    componentDidMount(){
        this.getInvitedTo();
    }

    handleInviteError(response, intent){
      const {handleError, history} = this.props;

      if(response.status == 400){
         handleError(response, intent + ".  The invitation may have been cancelled by the sender");
      } else {
         handleError(response, intent);
      }
    }

    acceptInvitation({lookup, hubId}){
        const {setLoading, history} = this.props;
        setLoading(true, "Accepting...");

        ContentServerClient.acceptInvitation(this.handleInviteError.bind(this), {lookup, hubId})
        .then(() => {
            setLoading(false);
            this.getInvitedTo();
            history.push(`/hubs/${hubId}-Loading/libraries?state=accepted`);
        })
        .catch((err) => setLoading(false))
    }

    rejectInvitation({lookup, hubId, hubname}){
        const {setLoading, history, location: {pathname}} = this.props;
        setLoading(true, "Rejecting...");

        ContentServerClient.rejectInvitation(this.handleInviteError.bind(this), {lookup, hubId})
        .then(() => {
            setLoading(false);
            this.getInvitedTo();
            history.push(`${pathname}?state=rejected&hubname=${hubname}`);
        })
        .catch((err) => setLoading(false))
    }

    getInvitedTo(){
        const {setLoading, handleError} = this.props;
        // dont throw errors from toasts
        ContentServerClient.getInvitedToHub(()=>{}) // this.props.handleError
            .then(({hubs}) => this.setState({invitedTo: {show: true, hubs}}))
            .catch(() => setLoading(false));
    }

    render() {
        const {invitedTo} = this.state;

        return  <Toast getTallestToast={this.props.getTallestToast} hasClose={false} show={invitedTo.show && invitedTo.hubs.length > 0} toastName="invitedTo" type="invitation">
                    {invitedTo.hubs.map(({id:hubId, name:hubname, owner:{name}, invite: [{lookup}]}) =>
                        <div className="contInvitation" key={hubId}>
                            <p className="text"><span className="bold">{name}</span> has invited you to edit the {fullHubAlias} <span className="bold">{hubname}</span></p>
                            <div className="contOptions">
                                <button className="button" onClick={() => this.acceptInvitation({lookup, hubId})}>Accept Invitation</button>
                                <button className="button transparent" onClick={() => this.rejectInvitation({lookup, hubId, hubname})}>Decline Invitation</button>
                            </div>
                        </div>
                    )}
                </Toast>
    }
}

module.exports = InvitationsToastHub;
